import styled from '@emotion/styled';
import mq from 'theme/mediaQueries'
import { InputForm } from 'components/Form/components'

export const Container = styled.div`
  grid-template-columns: 50px auto 150px 150px 100px;

  ${mq({
    display: ['block', 'block', 'grid'],
  })}
`

export const InputFormStyled = styled(InputForm)`
  margin-bottom: 0;

  input {
    text-align: right;
  }
`
